export default {"src":"/_next/static/media/hero-md.9cb81a5f.svg","height":498,"width":694,"blurWidth":0,"blurHeight":0};